<template>
  <div class="sweep_code_success_page">
    <div>扫码成功</div>
  </div>
</template>

<script>
  export default {
    name: 'SweepCodeSuccess',
    data() {
      return {}
    }
  }
</script>

<style lang="less" scoped>
.sweep_code_success_page {
  width: 100%;
  height: 100%;
}
</style>